import React from "react";

function VideoMute() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="47"
      viewBox="0 0 47 47"
    >
      <g
        id="Audio_Off_Icon"
        data-name="Audio Off Icon"
        transform="translate(-0.18 0)"
      >
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="23.5"
          cy="23.5"
          r="23.5"
          transform="translate(0.18 0)"
          opacity="0.7"
        />
        <g
          id="Icon_akar-sound-off"
          data-name="Icon akar-sound-off"
          transform="translate(11.765 14.19)"
        >
          <path
            id="Path_19898"
            data-name="Path 19898"
            d="M31.051,20.551,24,13.5m7.051,0L24,20.551"
            transform="translate(-7.549 -7.625)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            id="Path_19899"
            data-name="Path 19899"
            d="M3,18.878V11.922A1.2,1.2,0,0,1,4.175,10.7H8.389a1.152,1.152,0,0,0,.831-.358l3.525-3.981a1.17,1.17,0,0,1,2.006.865v16.35a1.169,1.169,0,0,1-2.016.853L9.221,20.47A1.152,1.152,0,0,0,8.38,20.1h-4.2A1.2,1.2,0,0,1,3,18.878Z"
            transform="translate(-3 -6)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default VideoMute;
